"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// `addPAliasMethod` is (necessarily) mutually recursive with `addUtilityForType`
// so it is defined in "../addUtilityForType.ts"
